import { BaseModel } from "../base-model";
import { IPropertyProspectionModel } from "./property-prospection.model";

  export interface IPropertyDetailViewModeModel {
    ActualDone?: boolean;
    AdditionalCharges?: number;
    Address?: string;
    Admin?: string;
    AnnuityIndexedId?: number;
    AnnuityTypeId?: number;
    //Architetures?: IPropertyMultModel[];
    Area?: string;
    AreaApplicationId?: number;
    AsBuiltId?: number;
    AtticComment?: string;
    AutoSendReportDate?: string;
    AvailableComment?: string;
    BaseActualCost?: number;
    BaseIndex?: number;
    BaseRent?: number;
    BathroomComment?: string;
    Bouquet?: number;
    BoxNumber?: string;
    BuildingId?: number;
    CadastralDivision?: string;
    CadastralEntity?: string;
    CadastralIncome?: number;
    CadastralIncomeI?: number;
    CadastralNumber?: string;
    CadastralRegisteredArea?: string;
    CadastralSection?: string;
    ChargeComment?: string;
    ChargesIndex?: number;
    ChargesOwner?: number;
    ChargesOwnerComment?: string;
    ChargesRenter?: number;
    CheckupId?: string;
    CheckupLatestTransactionId?: number;
    CityId?: number;
    CityName?: string;
    CityName2?: string;
    CityPostcode?: string;
    Classement?: string;
    CO2Emission?: number;
    Comment?: string;
    Commission?: string;
    CommissionPercent?: number;
    CommissionTypeId?: number;
    ConditionComment?: string;
    ConditionId?: number;
    Construction?: number;
    ConstructionComment?: string;
    ConstructionId?: number;
    ConstructionType?: number;
    ConstructionYear?: number;
    ContractCanceledReason?: string;
    ContractCondition?: string;
    ContractConditionDate?: string;
    ContractDate?: string;
    ContractDeedDate?: string;
    ContractTransferDate?: string;
    CountryId?: number;
    CountryName?: string;
    CreatedDate?: string;
    CurrencyType?: number;
    CurrentRentalIncomeAnnual?: number;
    CurrentRentalIncomeMonthly?: number;
    CurrentRentalIncomeYield?: number;
    CZaamCode?: string;
    DepositAmount?: number;
    DepositBank?: string;
    DepositNumber?: string;
    DepositTypeId?: number;
    Depth?: number;
    //Descriptions?: IPropertyDescriptionModel[];
    DisableEPC?: boolean;
    //Documents?: IPropertyDocumentModel[];
    ElectricityStateId?: number;
    EnergyPerformance?: number;
    EnvironmentAbbr?: string;
    EnvironmentCableTVComment?: string;
    EnvironmentCommerceComment?: string;
    EnvironmentCommerceValue?: number;
    EnvironmentConnectionsComment?: string;
    EnvironmentConnectionsValue?: number;
    EnvironmentDrainComment?: string;
    EnvironmentElectricityComment?: string;
    EnvironmentGasComment?: string;
    EnvironmentQuietComment?: string;
    EnvironmentQuietValue?: number;
    //Environments?: IPropertyMultModel[];
    EnvironmentSchoolComment?: string;
    EnvironmentSchoolValue?: number;
    EnvironmentTelephoneComment?: string;
    EnvironmentWaterComment?: string;
    EPCELevel?: number;
    EPCExpiryDate?: string;
    EPCExtra?: string;
    EPCLabelId?: number;
    EPCTotal?: number;
    EstimatedValue?: number;
    //ExteriorStates?: IPropertyMultModel[];
    ExternalId?: string;
    FacebookDate?: string;
    FacebookExternalLink?: string;
    FacebookId?: string;
    FacebookPageId?: string;
    FBFloor2?: number;
    FBFloors?: number;
    FBInteriorDoors?: number;
    FBKitchen?: number;
    FBSanitary?: number;
    FBSkirtingBoards?: number;
    FBWallTiles?: number;
    FloodRiscAreaId?: number;
    FloodRiskId?: number;
    FloodZoneId?: number;
    FloodZoneGScore?: number;
    FloodZonePScore?: number;
    Floor?: number;
    Floorplan?: number;
    FloorplannerId?: string;
    FootPrintArea?: number;
    FreeAvailableDate?: string;
    FreeAvailableId?: number;
    FridgeId?: number;
    FrontWidth?: number;
    GaragePrice?: number;
    GardenSize?: number;
    GeogAbbr?: string;
    Getter2Id?: number;
    GooglePOVHeading?: number;
    GooglePOVPitch?: number;
    GoogleStreetShow?: boolean;
    GoogleStreetZoom?: number;
    GoogleX?: number;
    GoogleY?: number;
    GroundArea?: number;
    GroundCertificateCodeA?: string;
    GroundCertificateCodeB?: string;
    GroundCertificateDate?: string;
    GroundCertificateDecisionDE?: string;
    GroundCertificateDecisionEN?: string;
    GroundCertificateDecisionFR?: string;
    GroundCertificateDecisionNL?: string;
    GroundCertificateId?: number;
    GroundCertificateOurReference?: string;
    GroundCertificateYourReference?: string;
    GroundPart?: number;
    GroundWidth?: number;
    HasAllotmentPermitEndDate?: string;
    HasAllotmentPermitId?: number;
    HasAllotmentPermitStartDate?: string;
    HasAtrium?: boolean;
    HasAttic?: boolean;
    HasAutomaticIndex?: boolean;
    HasBoard?: boolean;
    HasCellar?: boolean;
    HasChargeIndex?: boolean;
    HasContractCancelled?: boolean;
    HasDeductable?: boolean;
    HasElevator?: boolean;
    HasEnvironmentCableTV?: boolean;
    HasEnvironmentDrain?: boolean;
    HasEnvironmentElectricity?: boolean;
    HasEnvironmentGas?: boolean;
    HasEnvironmentTelephone?: boolean;
    HasEnvironmentWater?: boolean;
    HasFunished?: boolean;
    HasGarage?: boolean;
    HasGarden?: boolean;
    HasAdministrativeMeasuresId?: number;
    HasJudicialDecisionId?: number;
    HasOffice?: boolean;
    HasOilCertificate?: boolean;
    HasPackingExterior?: boolean;
    HasParkingInterior?: boolean;
    HasPermitEndDate?: string;
    HasPermitId?: number;
    HasPermitStartDate?: string;
    HasPreemptiveRightsId?: number;
    HasPublishAddress?: boolean;
    HasSummonsId?: number;
    HasTerrace?: boolean;
    HeadDate1?: string;
    HeadDate2?: string;
    HeadType1Id?: number;
    HeadType2Id?: number;
    HeatingBId?: number;
    HeatingComment?: string;
    HeatingId?: number;
    HeritageIds?: string;
    HouseNumber?: string;
    Id?: number;
    InrBadkamer?: number;
    InrZolder?: number;
    //InteriorDecors?: IPropertyMultModel[];
    IntermMandateId?: number;
    IntermMandateReference?: string;
    IntermMandatePercent?: number;
    IntermSale?: number;
    IntermSalePercent?: number;
    InvoiceComment?: string;
    InvoicedAmount?: number;
    InvoiceDate?: string;
    InvoiceNumber?: string;
    InvoicePaidDate?: string;
    InvoiceRenterDate?: string;
    InvoiceRenterNumber?: string;
    InvoiceRenterPaidDate?: string;
    IsAllotmentPermetRenewable?: boolean;
    IsAnnex?: boolean;
    IsAnnuity?: boolean;
    IsDeleted?: boolean;
    IsInInvoiceOwner?: boolean;
    IsPermitRenewable?: boolean;
    IsPrepaymentDone?: boolean;
    IsPrepaymentPercentage?: boolean;
    IsPublishPrice?: boolean;
    IsVAT?: boolean;
    ItemSold?: boolean;
    JudicialDecision?: string;
    Key?: boolean;
    KeyDesc?: string;
    Kitchen1Id?: number;
    KitchenComment?: string;
    KitchenId?: number;
    LastChange?: number;
    LastIndex?: number;
    LastIndexationDate?: string;
    LayoutTypeId?: number;
    LevelChange?: number;
    Ligging?: number;
    ListingAgentCommission?: number;
    ListingAgentCommissionTypeId?: number;
    ListingAgentId?: number;
    LivingArea?: number;
    MaandelijkseLijfrente?: number;
    ManagerId?: number;
    MandateEndDate?: string;
    MandateStartDate?: string;
    MandateTypeId?: number;
    Map?: string;
    MaximumExpensiveEN?: string;
    MaximumExpensiveFR?: string;
    MaximumExpensiveNL?: string;
    ModifiedDate?: string;
    NegotiablePrice?: number;
    NeighbourhoodId?: number;
    NewItem?: boolean;
    NotarySalary?: number;
    NrRooms?: number;
    NumberOfBathRoom?: number;
    NumberOfBedRoom?: number;
    NumberOfFacades?: number;
    NumberOfFloor?: number;
    NumberOfGarage?: number;
    NumberOfHeads?: number;
    NumberOfPackingExterior?: number;
    NumberOfParkingInterior?: number;
    NumberOfPersons?: number;
    NumberOfShowerRoom?: number;
    NumberOfToilet?: number;
    OfficeArea?: number;
    OilCertificateOfInspectionId?: number;
    OilContent?: string;
    OilFurtherExploitationId?: number;
    OilPlacementId?: number;
    OilStateId?: number;
    OldPrice?: number;
    OriginalId?: number;
    OriginalPropertyId?: number;
    TerraceOrientationId?: number;
    GardenOrientationId?: number;
    OwnerAgencyFee?: number;
    OwnerAgreement?: number;
    OwnerInventory?: number;
    OwnerName?: string;
    OwnerVariours?: number;
    PackingExteriorPrice?: number;
    ParentGenerationId?: number;
    ParentObjectId?: number;
    ParkingInteriorPrice?: number;
    PaymentAmount?: number;
    PaymentComment?: string;
    PetAllowedId?: number;
    PhoneNumber?: string;
    //Pictures?: IPropertyPictureModel[];
    PlotStreet?: number;
    POIAirportDistance?: number;
    POIAirportDistanceComment?: string;
    POIBusDistance?: number;
    POIBusDistanceComment?: string;
    POIHighWayDistance?: number;
    POIHighWayDistanceComment?: string;
    POIMetroDistance?: number;
    POIMetroDistanceComment?: string;
    POIRadius?: number;
    POISchoolDistance?: number;
    POISchoolDistanceComment?: string;
    POIStationDistance?: number;
    POIStationDistanceComment?: string;
    POIStoresDistance?: number;
    POIStoresDistanceComment?: string;
    POITramDistance?: number;
    POITramDistanceComment?: string;
    PotentialRentalIncomeAnnual?: number;
    PotentialRentalIncomeMonthly?: number;
    PotentialRentalIncomeYield?: number;
    Prepayment?: number;
    PrepaymentComment?: number;
    PrepaymentDate?: string;
    PrepaymentPrecentage?: number;
    PrepaymentTaskContactId?: number;
    PrepaymentTypeId?: number;
    Price?: number;
    PriceUnitId?: number;
    ProjectId?: number;
    ProjectPlotsCreatedDate?: string;
    ProjectPlotsFollowUpDate?: string;
    ProlongationId?: number;
    ProlongationTaskId?: number;
    ProlongationTaskDate?: string;
    ProlongationTaskDone?: boolean;
    PropDesc?: string;
    PropertyTax?: number;
    PubBudget?: number;
    PurchaseYear?: number;
    PurposeDsc?: string;
    PurposeId?: number;
    RealCommission?: number;
    RearOrientationComment?: string;
    RearOrientationId?: number;
    ReasonForSelling?: string;
    ReceivedCancellationDate?: string;
    Record?: string;
    ReductionConstructionId?: number;
    ReductionPartLand?: number;
    Reference?: string;
    RegistrationPrice?: number;
    RegistrationType2Id?: number;
    RegistrationTypeId?: number;
    //Relations?: IPropertyRelationModel[];
    RentalSignatureDate?: string;
    Rented?: boolean;
    RentEndDate?: string;
    RenterAgencyFee?: number;
    RenterAgreement?: number;
    RenterInventory?: number;
    RenterVariours?: number;
    RentStartDate?: string;
    Rermarks?: string;
    Residence?: string;
    RiverBankZoneId?: number;
    RoofConditionId?: number;
    RoofCoveringId?: number;
    RoomsExt?: number;
    rowguid?: string;
    SalePrice?: number;
    SalesOpportunity?: number;
    SellerCommission?: number;
    SellerCommissionTypeId?: number;
    Servitudes?: string;
    Share?: number;
    ShopArea?: number;
    ShowerId?: number;
    ShowPrice?: number;
    SigningAgentCommission?: number;
    SigningAgentCommissionTypeId?: number;
    SigningAgentId?: number;
    SiteId?: number;
    SituationPlan?: string;
    SmokeDetector?: number;
    SmokingAllowedId?: number;
    SpecialConditions?: string;
    StartPrice?: number;
    StatusChangeComment?: string;
    StatusDsc?: string;
    StatusId?: number;
    StatusModifiedDate?: string;
    StoryComment?: string;
    Street2?: string;
    StyleOfBuildingAbbr?: string;
    SubStatusDate?: string;
    SubStatusId?: number;
    SubStatusModifiedDate?: string;
    SurfGround?: number;
    SurivalInterestId?: number;
    TelevisionId?: number;
    TenantFirstRefusalId?: number;
    TerraceArea?: number;
    ToiletId?: number;
    TotalArea?: number;
    TotalInvoiceRenter?: number;
    TransactionComment?: string;
    TwitterDate?: string;
    TwitterId?: number;
    TypeDescriptionCA?: string;
    TypeDescriptionDE?: string;
    TypeDescriptionEN?: string;
    TypeDescriptionFR?: string;
    TypeDescriptionNL?: string;
    TypeDescriptionSP?: string;
    TypeOfBuildingAbbr?: string;
    TypeOfContractId?: number;
    TypeOfPropertyDsc?: string;
    TypeOfPropertyId?: number;
    //TypeOfProps?: IPropertyMultModel[];
    TypeOfRoofComment?: string;
    TypeOfRoofId?: number;
    UniqueCode?: string;
    UnitOrder?: number;
    UsageAbbr?: string;
    //Usages?: IPropertyMultModel[];
    ValidFloodCertificateId?: number;
    VariousCosts?: number;
    VATBuilding?: number;
    VatValue?: number;
    VatValue2?: number | null;
    VirtualTour?: string;
    VirtualTour2?: string;
    VisitDuration?: number;
    Visitinghours?: string;
    WindowComments?: string;
    WindowFrameId?: number;
    WindowGlazingId?: number;
    //Rooms?: IPropertyRoomModel[];
    //Management?: IPropertyManagementModel;
    //ChargeElements?: IPropertyChargeElementModel[];
    //PublicUtilities?: IPropertyPublicUtilityModel[];
    //PicturesOfEnvironment?: IPropertyEnvironmentPicture[];
    //PoiOfEnvironment?: IPropertyEnvironmentPointMapList;
    //AvElectricalCost?: number;
    AvGasOilCost?: number;
    WorkingCapital?: number;
    ReserveCapital?: number;
    PromiseToBuyDate?: string;
    PromiseToRentDate?: string;
    CategoryTypeId?: number;
    Prospection?: IPropertyProspectionModel;
  }
  export class PropertyDetailViewModeModel extends BaseModel<IPropertyDetailViewModeModel>
    implements IPropertyDetailViewModeModel {
    // Documents: IPropertyDocumentModel[];
    // Pictures: IPropertyPictureModel[];
    // Rooms: IPropertyRoomModel[];
    // Descriptions: IPropertyDescriptionModel[];
    // Relations: IPropertyRelationModel[];
    // Management?: IPropertyManagementModel;
    ChargeElements?: any;
    // PoiOfEnvironment?: IPropertyEnvironmentPointMapList;
    // PicturesOfEnvironment?: IPropertyEnvironmentPicture[];
    Prospection?: IPropertyProspectionModel;
    CountryName?: string;
    /**
     *
     */
    constructor(option?: IPropertyDetailViewModeModel) {
      super(option);
    //   this.PicturesOfEnvironment = option.PicturesOfEnvironment || [];
    //   this.PoiOfEnvironment =
    //     option.PoiOfEnvironment || new PropertyEnvironmentPointMapList({});
    //   this.Prospection =  option.Prospection || new PropertyProspectionModel();
      this.CountryName = option.CountryName || null;
    }
  }
  